import { memo } from 'preact/compat';

import ShareModal from './Modal';

export default memo(ShareModal);
